import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreLoader = _resolveComponent("PreLoader")!
  const _component_MobileNavbar = _resolveComponent("MobileNavbar")!
  const _component_SearchModal = _resolveComponent("SearchModal")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CartModal = _resolveComponent("CartModal")!
  const _component_RTLBtn = _resolveComponent("RTLBtn")!
  const _component_BackToUp = _resolveComponent("BackToUp")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PreLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_MobileNavbar),
    _createVNode(_component_SearchModal),
    _createVNode(_component_router_view),
    _createVNode(_component_CartModal),
    _createVNode(_component_RTLBtn),
    _createVNode(_component_BackToUp)
  ], 64))
}